import { EnteredAddress } from '@models/validation';

export const isUnique = (suggestion: EnteredAddress, uniqueSuggestions: string[]): boolean => {
  const formattedSuggestion = `${suggestion.street1}${suggestion.city}`;
  const isDuplicate = uniqueSuggestions.includes(formattedSuggestion);
  if (isDuplicate) {
    return false;
  }
  uniqueSuggestions.push(formattedSuggestion);
  return true;
};
